document.addEventListener('DOMContentLoaded', () => {

    // Check if we're on a mobile device based on screen width (or use a more advanced check if needed)
    const isMobile = window.innerWidth <= 768; // You can adjust this breakpoint based on your design

    const observeElements = () => {
        let allElements = document.querySelectorAll(
            '.fade-in-up, .fade-in-left, .fade-in-scale, .fade-in');

        // If on mobile, replace 'fade-in-left' with 'fade-in-up' for all relevant elements
        if (isMobile) {
            allElements.forEach(element => {
                if (element.classList.contains('fade-in-left')) {
                    element.classList.remove('fade-in-left');
                    element.classList.add('fade-in'); // Replace with 'fade-in'
                }
            });
        }

        const tailwindClasses = [
            'animate-fade-in-up',
            'animate-fade-in-left',
            'animate-fade-in-scale',
            'animate-fade-in',
        ];

        if (allElements.length === 0) {
            // If no elements are found, wait for the next mutation
            return;
        }

        // Set different threshold for mobile and desktop
        const thresholdValue = isMobile ? 0 : 0.3; // Adjust the mobile threshold if necessary

        const observer = new IntersectionObserver(entries => {
            entries.forEach((entry, index) => {
                if (entry.isIntersecting) {

                    // Check classes and add animation class
                    switch (true) {
                        case entry.target.classList.contains('fade-in-up'):
                            entry.target.classList.add(tailwindClasses[0]);
                            break;
                        case entry.target.classList.contains('fade-in-left'):
                            entry.target.classList.add(tailwindClasses[1]);
                            break;
                        case entry.target.classList.contains('fade-in-scale'):
                            entry.target.classList.add(tailwindClasses[2]);
                            break;
                        case entry.target.classList.contains('fade-in'):
                            entry.target.classList.add(tailwindClasses[3]);
                            break;
                    }
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: thresholdValue }); // Use the mobile or desktop threshold

        allElements.forEach(element => {
            observer.observe(element);
        });
    };

    // Create a Mutation Observer to watch for changes in the DOM
    const mutationObserver = new MutationObserver(observeElements);
    mutationObserver.observe(document.body, { childList: true, subtree: true });

    // Initial call to check if elements are already in the DOM
    observeElements();

    // For every element with id flowcard-[id], add a 200ms delay to the animation
    const flowcards = document.querySelectorAll('[id^="flowcard-"]');
    flowcards.forEach((flowcard, index) => {
        if (!isMobile) {
            flowcard.style.animationDelay = `${index * 300}ms`;
            return;
        }
        flowcard.style.animationDelay = `${index * 100}ms`;
    });

});
